import $ from "jquery";

function ToastMessage() {
  $(".js-toast-close").on("click", function () {
    const toast = $(this).closest(".js-toast");

    toast.fadeOut();
  });
}

export { ToastMessage };
